module.exports = __webpack_public_path__ + "img/image3.9ad90016.png";